export enum TimezoneNames {
  ET = 'Eastern',
  CT = 'Central',
  MT = 'Mountain',
  PT = 'Pacific',
  AL = 'Alaska',
  HI = 'Hawaii'
}

export const TimezoneTagToNameMap: { [key: string]: string; } = {
  'America/New_York': TimezoneNames.ET,
  'America/Chicago': TimezoneNames.CT,
  'America/Indiana/Indianapolis': TimezoneNames.CT,
  'America/Phoenix': TimezoneNames.MT,
  'America/Denver': TimezoneNames.MT,
  'America/Los_Angeles': TimezoneNames.PT,
  'America/Juneau': TimezoneNames.AL,
  'Pacific/Honolulu': TimezoneNames.HI,
};
